// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Collapse,
//   IconButton,
//   Typography,
//   Tooltip,
//   AppBar,
//   Toolbar,
//   useTheme,
//   useMediaQuery,
//   SwipeableDrawer,
// } from "@mui/material";
// import {
//   ExpandLess,
//   ExpandMore,
//   Dashboard,
//   Business,
//   Group,
//   Article,
//   Help,
//   ChevronLeft,
//   ChevronRight,
//   Menu as MenuIcon,
//   Category,
//   QueryStats,
//   Leaderboard,
//   DiscountOutlined,
//   BrandingWatermark,
//   QuestionAnswer,
//   ContactPage,
//   Notifications,
// } from "@mui/icons-material";
// import {
//   BadgeIndianRupee,
//   BookOpenText,
//   Cog,
//   Handshake,
//   LanguagesIcon,
//   Radius,
//   TicketX,
//   Timer,
//   Truck,
//   User,
//   User2,
//   Users,
//   Warehouse,
// } from "lucide-react";

// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import LocalOfferIcon from '@mui/icons-material/LocalOffer';
// import { useNavigate, useLocation } from "react-router-dom";
// import PageRoutes from "../routes/PageRoutes";
// import PageSideRoute from "../routes/PageSideRoute";
// import ViewCarouselRoundedIcon from "@mui/icons-material/ViewCarouselRounded";
// import axios from "axios";
// import apiUrl from "../Config";

// const drawerWidth = 280;

// const iconMapping = {
//   "Dashboard": <Dashboard />,
//   "Management": <Group />,
//   "Roles Management": <User />,
//   "Booking Management": <AccountCircleIcon />,
//   "Service Catalog": <Category />,
//   "Offer Management": <DiscountOutlined />,
//   "Vehicle Brands & Models": <BrandingWatermark />,
//   "Delivery Management": <Truck />,
//   "Time Slot Settings": <Timer />,
//   "Push Notifications": <Notifications />,
//   "Cancellation Policy": <TicketX />,
//   "Referral Program": <Cog />,
//   "Banner Management": <ViewCarouselRoundedIcon />,
//   "Commission & Taxes": <BadgeIndianRupee />,
//   "Customer Enquiries": <QuestionAnswer />,
//   "CMS": <Help />,
// };

// const SidebarItem = ({
//   item,
//   openSidebar,
//   depth = 0,
//   currentPath,
//   expandedItems,
//   setExpandedItems,
//   onItemClick,
// }) => {
//   const hasChildren = Array.isArray(item.children);
//   const isExpanded = expandedItems.includes(item.label);

//   const navigate = useNavigate();

//   // Check if the current path matches this item or any of its children
//   const isSelected =
//     item.link === currentPath ||
//     (hasChildren && item.children.some((child) => child.link === currentPath));

//   const handleClick = () => {
//     if (hasChildren) {
//       setExpandedItems((prev) => {
//         if (depth === 0) {
//           return isExpanded ? [] : [item.label];
//         } else {
//           return isExpanded
//             ? prev.filter((label) => label !== item.label)
//             : [...prev, item.label];
//         }
//       });
//     }

//     if (item.link) {
//       navigate(item.link);
//     }

//     if (onItemClick && !hasChildren) onItemClick();
//   };

//   return (
//     <>
//       <Box sx={{ width: "100%" }}>
//         <Box>
//           <ListItem
//             button
//             onClick={handleClick}
//             sx={{
//               backgroundColor: isSelected ? "red" : "transparent",
//               "&:hover": {
//                 backgroundColor: isSelected
//                   ? "darkred"
//                   : "rgba(255, 255, 255, 0.1)",
//               },
//               pl: 2 + depth * 1.5,
//             }}
//           >
//             <Tooltip title={!openSidebar ? item.label : ""} placement="right">
//               <ListItemIcon sx={{ color: "#fff", minWidth: 40, py: 1 }}>
//                 {item.icon || <Box sx={{ width: 18 }} />}
//               </ListItemIcon>
//             </Tooltip>

//             {openSidebar && (
//               <ListItemText
//                 primary={item.label}
//                 primaryTypographyProps={{
//                   color: "#fff",
//                   fontSize: depth === 0 ? "14px" : "0.85rem",
//                   fontWeight: depth === 0 ? 500 : 400,
//                 }}
//               />
//             )}

//             {hasChildren &&
//               openSidebar &&
//               (isExpanded ? <ExpandLess /> : <ExpandMore />)}
//           </ListItem>

//           {hasChildren && (
//             <Collapse in={isExpanded} timeout="auto" unmountOnExit>
//               <List disablePadding>
//                 {item.children.map((child, index) => (
//                   <SidebarItem
//                     key={index}
//                     item={child}
//                     openSidebar={openSidebar}
//                     depth={depth + 1}
//                     currentPath={currentPath}
//                     expandedItems={expandedItems}
//                     setExpandedItems={setExpandedItems}
//                     onItemClick={onItemClick}
//                   />
//                 ))}
//               </List>
//             </Collapse>
//           )}
//         </Box>
//       </Box>
//     </>
//   );
// };

// const SidebarContent = ({
//   openSidebar,
//   currentPath,
//   expandedItems,
//   setExpandedItems,
//   onItemClick,
//   menuItems,
// }) => (
//   <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
//     {/* Header */}
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: openSidebar ? "space-between" : "center",
//         p: 2,
//         minHeight: { sm: "auto", md: 64 },
//         bgcolor: "#111",
//         borderBottom: "1px solid #333",
//       }}
//     >
//       {openSidebar ? (
//         <Typography variant="h6" fontWeight="bold" color="#fff">
//           Xpress Wheel
//         </Typography>
//       ) : (
//         <Typography
//           variant="h6"
//           fontWeight="bold"
//           color="red"
//           paddingLeft={"28px"}
//         >
//           I
//         </Typography>
//       )}
//     </Box>
//     {/* Menu Items */}
//     <List
//       disablePadding
//       sx={{ overflowY: "scroll", scrollbarWidth: "none", cursor: "pointer" }}
//     >
//       {menuItems.map((item, index) => (
//         <SidebarItem
//           key={index}
//           item={{ ...item, icon: iconMapping[item.label] }}
//           openSidebar={openSidebar}
//           currentPath={currentPath}
//           expandedItems={expandedItems}
//           setExpandedItems={setExpandedItems}
//           onItemClick={onItemClick}
//         />
//       ))}
//     </List>
//   </Box>
// );

// const Sidebar = () => {
//   const [openSidebar, setOpenSidebar] = useState(true);
//   const [expandedItems, setExpandedItems] = useState([]);
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [menuItems, setMenuItems] = useState([]);

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const location = useLocation();
//   const currentPath = location.pathname;

//   useEffect(() => {
//     const fetchMenu = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         if (!token) return;

//         const response = await axios.get(`${apiUrl}/employee/get-menu-items`, {
//           headers: {
//             Authorization: `Bearer ${token}`
//           }
//         });

//         if (response.data.status) {
//           setMenuItems(response.data.menu);
//         }
//       } catch (error) {
//         console.log(error,'error')
//         console.error("Error fetching sidebar menu:", error);
//       }
//     };

//     fetchMenu();
//   }, []);

//   // Drawer content for both desktop and mobile
//   const drawerContent = (
//     <SidebarContent
//       openSidebar={openSidebar}
//       currentPath={currentPath}
//       expandedItems={expandedItems}
//       setExpandedItems={setExpandedItems}
//       onItemClick={() => {
//         if (isMobile) setMobileOpen(false);
//       }}
//       menuItems={menuItems}
//     />
//   );

//   return (
//     <Box sx={{ display: "flex", minHeight: "100vh" }}>
//       {/* Sidebar and Navbar */}
//       <>
//         {isMobile && (
//           <AppBar
//             position="fixed"
//             sx={{ zIndex: theme.zIndex.drawer + 1, bgcolor: "#111" }}
//           >
//             <Toolbar>
//               <IconButton
//                 color="inherit"
//                 edge="start"
//                 onClick={() => setMobileOpen((prev) => !prev)}
//                 sx={{ mr: 2 }}
//               >
//                 <MenuIcon />
//               </IconButton>
//               <Typography variant="h6" noWrap component="div">
//                 Xpress Wheel
//               </Typography>
//             </Toolbar>
//           </AppBar>
//         )}

//         {/* Desktop Drawer */}
//         {!isMobile && (
//           <Drawer
//             variant="permanent"
//             open={openSidebar}
//             sx={{
//               width: openSidebar ? drawerWidth : 72,
//               flexShrink: 0,
//               "& .MuiDrawer-paper": {
//                 width: openSidebar ? drawerWidth : 72,
//                 boxSizing: "border-box",
//                 backgroundColor: "#111",
//                 color: "#fff",
//                 overflow: "hidden",
//               },
//             }}
//           >
//             {/* Header with collapse button */}
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: openSidebar ? "space-between" : "center",
//                 p: 2,
//                 minHeight: 64,
//                 bgcolor: "#111",
//                 borderBottom: "1px solid #333",
//               }}
//             >
//               {openSidebar ? (
//                 <Typography variant="h6" fontWeight="bold" color="#fff">
//                   Xpress Wheel
//                 </Typography>
//               ) : (
//                 <Typography
//                   variant="h6"
//                   fontWeight="bold"
//                   color="red"
//                   paddingLeft={"28px"}
//                 >
//                   I
//                 </Typography>
//               )}

//               <IconButton
//                 onClick={() => setOpenSidebar(!openSidebar)}
//                 sx={{ color: "#fff", ml: openSidebar ? 0 : "auto" }}
//               >
//                 {openSidebar ? <ChevronLeft /> : <ChevronRight />}
//               </IconButton>
//             </Box>
//             {/* Menu Items */}
//             <List
//               disablePadding
//               sx={{
//                 overflowY: "scroll",
//                 scrollbarWidth: "none",
//                 cursor: "pointer",
//               }}
//             >
//               {menuItems.map((item, index) => (
//                 <SidebarItem
//                   key={index}
//                   item={{ ...item, icon: iconMapping[item.label] }}
//                   openSidebar={openSidebar}
//                   currentPath={currentPath}
//                   expandedItems={expandedItems}
//                   setExpandedItems={setExpandedItems}
//                 />
//               ))}
//             </List>
//           </Drawer>
//         )}

//         {/* Mobile Drawer */}
//         {isMobile && (
//           <SwipeableDrawer
//             anchor="left"
//             open={mobileOpen}
//             onOpen={() => setMobileOpen(true)}
//             onClose={() => setMobileOpen(false)}
//             sx={{
//               "& .MuiDrawer-paper": {
//                 width: drawerWidth,
//                 backgroundColor: "#111",
//                 color: "#fff",
//               },
//             }}
//           >
//             {drawerContent}
//           </SwipeableDrawer>
//         )}
//       </>

//       {/* Main Content */}
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           width: "100%",
//           mt: isMobile ? "64px" : 0,
//           transition: "margin 0.3s",
//         }}
//       >
//         <PageRoutes />
//       </Box>
//     </Box>
//   );
// };
// export default Sidebar;


import React, { useState, useEffect } from "react";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  IconButton,
  Typography,
  Tooltip,
  AppBar,
  Toolbar,
  useTheme,
  useMediaQuery,
  SwipeableDrawer,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  Dashboard,
  Business,
  Group,
  Article,
  Help,
  ChevronLeft,
  ChevronRight,
  Menu as MenuIcon,
  Category,
  QueryStats,
  Leaderboard,
  DiscountOutlined,
  BrandingWatermark,
  QuestionAnswer,
  ContactPage,
  Notifications,
} from "@mui/icons-material";
import {
  BadgeIndianRupee,
  BookOpenText,
  Cog,
  Handshake,
  LanguagesIcon,
  Radius,
  TicketX,
  Timer,
  Truck,
  User,
  User2,
  Users,
  Warehouse,
} from "lucide-react";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { useNavigate, useLocation } from "react-router-dom";
import PageRoutes from "../routes/PageRoutes";
import ViewCarouselRoundedIcon from "@mui/icons-material/ViewCarouselRounded";
import axios from "axios";
import apiUrl from "../Config";

const drawerWidth = 280;

const iconMapping = {
  "Dashboard": <Dashboard />,
  "Management": <Group />,
  "Roles Management": <User />,
  "Booking Management": <AccountCircleIcon />,
  "Service Catalog": <Category />,
  "Offer Management": <DiscountOutlined />,
  "Vehicle Brands & Models": <BrandingWatermark />,
  "Delivery Management": <Truck />,
  "Time Slot Settings": <Timer />,
  "Push Notifications": <Notifications />,
  "Cancellation Policy": <TicketX />,
  "Referral Program": <Cog />,
  "Banner Management": <ViewCarouselRoundedIcon />,
  "Commission & Taxes": <BadgeIndianRupee />,
  "Customer Enquiries": <QuestionAnswer />,
  "CMS": <Help />,
  "Logout":<LogoutIcon/>
};

const SidebarItem = ({
  item,
  openSidebar,
  depth = 0,
  currentPath,
  expandedItems,
  setExpandedItems,
  onItemClick,
}) => {
  const hasChildren = Array.isArray(item.children);
  const isExpanded = expandedItems.includes(item.label);
  const navigate = useNavigate();

  const isSelected =
    item.link === currentPath ||
    (hasChildren && item.children.some((child) => child.link === currentPath));

  // const handleClick = () => {
  //   if (hasChildren) {
  //     setExpandedItems((prev) => {
  //       if (depth === 0) {
  //         return isExpanded ? [] : [item.label];
  //       } else {
  //         return isExpanded
  //           ? prev.filter((label) => label !== item.label)
  //           : [...prev, item.label];
  //       }
  //     });
  //   }
  //   if (item.link) navigate(item.link);
  //   if (onItemClick && !hasChildren) onItemClick();
  // };
// const handleClick = () => {

//   // LOGOUT ACTION (IMPORTANT)
//   if (item.module === "Logout") {
//     localStorage.removeItem("token"); // clear login token

//     navigate("/"); // redirect to login page

//     if (onItemClick) onItemClick();

//     return; // stop further execution
//   }

//   // expand/collapse menu
//   if (hasChildren) {
//     setExpandedItems((prev) => {
//       if (depth === 0) {
//         return isExpanded ? [] : [item.label];
//       } else {
//         return isExpanded
//           ? prev.filter((label) => label !== item.label)
//           : [...prev, item.label];
//       }
//     });
//   }

//   // normal navigation
//   if (item.link) {
//     navigate(item.link);
//   }

//   // close mobile drawer
//   if (onItemClick && !hasChildren) {
//     onItemClick();
//   }
// };

const handleClick = async () => {
  try {
    // LOGOUT ACTION
    if (item.module === "Logout") {
      const token = localStorage.getItem("token");

      await axios.post(
        `${apiUrl}/employee/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Clear local storage after successful logout
      localStorage.removeItem("token");
      localStorage.removeItem("employee");

      // Redirect to login page
      navigate("/");

      // Close drawer if mobile
      if (onItemClick) onItemClick();

      return;
    }

    // Expand / collapse menu
    if (hasChildren) {
      setExpandedItems((prev) => {
        if (depth === 0) {
          return isExpanded ? [] : [item.label];
        } else {
          return isExpanded
            ? prev.filter((label) => label !== item.label)
            : [...prev, item.label];
        }
      });
    }

    // Normal navigation
    if (item.link) {
      navigate(item.link);
    }

    // Close mobile drawer
    if (onItemClick && !hasChildren) {
      onItemClick();
    }
  } catch (error) {
    console.log("Logout error:", error);

    // Even if API fails, clear token and redirect
    localStorage.removeItem("token");
    localStorage.removeItem("employee");

    navigate("/");
  }
};
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box>
          <ListItem
            button
            onClick={handleClick}
            sx={{
              backgroundColor: isSelected ? "red" : "transparent",
              "&:hover": {
                backgroundColor: isSelected
                  ? "darkred"
                  : "rgba(255, 255, 255, 0.1)",
              },
              pl: 2 + depth * 1.5,
            }}
          >
            <Tooltip title={!openSidebar ? item.label : ""} placement="right">
              <ListItemIcon sx={{ color: "#fff", minWidth: 40, py: 1 }}>
                {item.icon || <Box sx={{ width: 18 }} />}
              </ListItemIcon>
            </Tooltip>

            {openSidebar && (
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  color: "#fff",
                  fontSize: depth === 0 ? "14px" : "0.85rem",
                  fontWeight: depth === 0 ? 500 : 400,
                }}
              />
            )}

            {hasChildren &&
              openSidebar &&
              (isExpanded ? <ExpandLess /> : <ExpandMore />)}
          </ListItem>

          {hasChildren && (
            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
              <List disablePadding>
                {item.children.map((child, index) => (
                  <SidebarItem
                    key={index}
                    item={child}
                    openSidebar={openSidebar}
                    depth={depth + 1}
                    currentPath={currentPath}
                    expandedItems={expandedItems}
                    setExpandedItems={setExpandedItems}
                    onItemClick={onItemClick}
                  />
                ))}
              </List>
            </Collapse>
          )}
        </Box>
      </Box>
    </>
  );
};

const SidebarContent = ({
  openSidebar,
  currentPath,
  expandedItems,
  setExpandedItems,
  onItemClick,
  menuItems,
}) => (
  <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: openSidebar ? "space-between" : "center",
        p: 2,
        minHeight: { sm: "auto", md: 64 },
        bgcolor: "#111",
        borderBottom: "1px solid #333",
      }}
    >
      {openSidebar ? (
        <Typography variant="h6" fontWeight="bold" color="#fff">
          Xpress Wheel
        </Typography>
      ) : (
        <Typography variant="h6" fontWeight="bold" color="red" paddingLeft={"28px"}>
          I
        </Typography>
      )}
    </Box>
    <List
      disablePadding
      sx={{ overflowY: "scroll", scrollbarWidth: "none", cursor: "pointer" }}
    >
      {menuItems.map((item, index) => (
        <SidebarItem
          key={index}
          item={{ ...item, icon: iconMapping[item.label] }}
          openSidebar={openSidebar}
          currentPath={currentPath}
          expandedItems={expandedItems}
          setExpandedItems={setExpandedItems}
          onItemClick={onItemClick}
        />
      ))}
    </List>
  </Box>
);

const Sidebar = () => {
  const [openSidebar, setOpenSidebar] = useState(true);
  const [expandedItems, setExpandedItems] = useState([]);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [menuItems, setMenuItems] = useState([]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();
  const currentPath = location.pathname;

  // ✅ Check if user is on the login page (no token = show only routes, no sidebar)
  const token = localStorage.getItem("token");
  const isLoginPage = currentPath === "/";

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const response = await axios.get(`${apiUrl}/employee/get-menu-items`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data.status) {
          setMenuItems(response.data.menu);
        }
      } catch (error) {
        console.error("Error fetching sidebar menu:", error);
      }
    };

    fetchMenu();
  }, [token]); // re-fetch when token changes (i.e., after login)

  // ✅ If not logged in or on login page, render only the routes (Login page)
  if (!token || isLoginPage) {
    return <PageRoutes />;
  }

  const drawerContent = (
    <SidebarContent
      openSidebar={openSidebar}
      currentPath={currentPath}
      expandedItems={expandedItems}
      setExpandedItems={setExpandedItems}
      onItemClick={() => {
        if (isMobile) setMobileOpen(false);
      }}
      menuItems={menuItems}
    />
  );

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <>
        {isMobile && (
          <AppBar
            position="fixed"
            sx={{ zIndex: theme.zIndex.drawer + 1, bgcolor: "#111" }}
          >
            <Toolbar>
              <IconButton
                color="inherit"
                edge="start"
                onClick={() => setMobileOpen((prev) => !prev)}
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" noWrap component="div">
                Xpress Wheel
              </Typography>
            </Toolbar>
          </AppBar>
        )}

        {/* Desktop Drawer */}
        {!isMobile && (
          <Drawer
            variant="permanent"
            open={openSidebar}
            sx={{
              width: openSidebar ? drawerWidth : 72,
              flexShrink: 0,
              "& .MuiDrawer-paper": {
                width: openSidebar ? drawerWidth : 72,
                boxSizing: "border-box",
                backgroundColor: "#111",
                color: "#fff",
                overflow: "hidden",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: openSidebar ? "space-between" : "center",
                p: 2,
                minHeight: 64,
                bgcolor: "#111",
                borderBottom: "1px solid #333",
              }}
            >
              {openSidebar ? (
                <Typography variant="h6" fontWeight="bold" color="#fff">
                  Xpress Wheel
                </Typography>
              ) : (
                <Typography variant="h6" fontWeight="bold" color="red" paddingLeft={"28px"}>
                  I
                </Typography>
              )}
              <IconButton
                onClick={() => setOpenSidebar(!openSidebar)}
                sx={{ color: "#fff", ml: openSidebar ? 0 : "auto" }}
              >
                {openSidebar ? <ChevronLeft /> : <ChevronRight />}
              </IconButton>
            </Box>
            <List
              disablePadding
              sx={{ overflowY: "scroll", scrollbarWidth: "none", cursor: "pointer" }}
            >
              {menuItems.map((item, index) => (
                <SidebarItem
                  key={index}
                  item={{ ...item, icon: iconMapping[item.label] }}
                  openSidebar={openSidebar}
                  currentPath={currentPath}
                  expandedItems={expandedItems}
                  setExpandedItems={setExpandedItems}
                />
              ))}
            </List>
          </Drawer>
        )}

        {/* Mobile Drawer */}
        {isMobile && (
          <SwipeableDrawer
            anchor="left"
            open={mobileOpen}
            onOpen={() => setMobileOpen(true)}
            onClose={() => setMobileOpen(false)}
            sx={{
              "& .MuiDrawer-paper": {
                width: drawerWidth,
                backgroundColor: "#111",
                color: "#fff",
              },
            }}
          >
            {drawerContent}
          </SwipeableDrawer>
        )}
      </>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: "100%",
          mt: isMobile ? "64px" : 0,
          transition: "margin 0.3s",
        }}
      >
        <PageRoutes />
      </Box>
    </Box>
  );
};

export default Sidebar;